"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Custom filter for cards and navigation items.
 */
var RootEntityConfigCustomFilteringService = /** @class */ (function () {
    function RootEntityConfigCustomFilteringService() {
    }
    return RootEntityConfigCustomFilteringService;
}());
exports.RootEntityConfigCustomFilteringService = RootEntityConfigCustomFilteringService;
//# sourceMappingURL=root-entity-config-custom-filtering.service.js.map